<template>
  <div class="container member-withdraw-list">
    <div class="common-header-wrap">
      <mt-header :title="$t('Gold Card Withdraw')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>

    <div class="content">
      <div class="centerbox">
        <div class="field-line-right" slot="right" style="padding-top: 10px;">
          <span v-if="address_type == 'BEP20'">USDT-BNB Smart Chain (BEP20)</span>
          <span v-else>USDT Address (opBNB)</span>
        </div>
        <flex-line
          v-if="bank_length > 0"
          class="field-line menu-item input-wrapper"
          :show-border="true"
        >
          <div class="field-line-right" slot="right">
            <span class="field-input" style="word-wrap: break-word;white-space: normal;text-align: left;display: inline-block;width: 100%;">
              {{ usdt_address }}
            </span>
          </div>
        </flex-line>

        <flex-line
          class="field-line menu-item input-wrapper"
          :show-border="true"
        >
          <span class="field-name">
            {{ $t("Withdrawal Amount") }}
          </span>
          <div class="field-line-right" slot="right">
            <input
              class="field-input"
              :placeholder="$t('Please enter')"
              type="number"
              v-model="amount"
            />
          </div>
        </flex-line>

        <flex-line
          class="field-line menu-item input-wrapper"
          :showPassword="showPassword"
          :toggleVisibility="toggleVisibility"
          :isPassword="true"
        >
          <span class="field-name">
            {{ $t("Payment Password") }}
          </span>
          <div class="field-line-right" slot="right">
            <input
              class="field-input"
              :type="showPassword ? 'text' : 'password'"
              :placeholder="$t('Please enter')"
              v-model="password"
            />
          </div>
        </flex-line>

        <div class="flex" style="margin-top: 0.5rem">
          <div class="f balance" style="text-align: left;cursor: pointer;" @click="onRetrieve">
            {{ $t("Forgot Password") }}?
          </div>
          <div class="balance">
            Gold Card Balance: {{ gold_card_balance }}
          </div>
        </div>

        <flex-line class="field-line input-wrapper" :show-border="true" style="background: #fafafa;border-radius: 5px;">
          <span class="field-name">{{ $t('Email.verification.code') }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input" type="number" maxlength="6" v-model="email_code"
              :placeholder="$t('Please enter')"
              :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
            <div @click="sendVerifyCode" class="common-btn send-btn">{{ sendStateTextMobile }}</div>
          </div>
        </flex-line>

        <div class="common-btn ds-button-large" @click="addWithdraw" v-if="btnShow">
          {{ $t("Submit") }}
        </div>
        <div class="common-btn ds-button-large" @click="goMemberbacklist" v-else>
          {{ $t("Add Recipient Account First") }} >>
        </div>
      </div>

      <div class="fundet">
        <div class="tit">{{ $t("Withdrawal Details") }}</div>
        <div
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
          style="padding-bottom: 10px"
        >
          <div class="list-wrapper" v-if="withdraw_list && withdraw_list.length">
            <div class="container-item" v-for="(item, index) in withdraw_list" :key="item.pdc_id">
              <div class="top-wrapper">
                <div class="left-wrapper">
                  <label class="status">{{ item.pdc_payment_state_text }}</label>
                  <label class="title">{{ $t("address") }}: {{ item.pdc_bank_no }}</label>
                </div>
                <div class="right-wrapper">
                  <label class="price">${{ item.pdc_amount }}</label>
                  <label class="subtitle">{{ $t("Withdrawal Amount") }}</label>
                </div>
              </div>
              <div class="center-wrapper" v-if="item.reason">
                <label class="desc" style="color: #fb2630">{{ $t("Cause of failure") }}: {{ item.reason }}</label>
              </div>
              <div class="center-wrapper">
                <label class="desc">{{ $t("Application Time") }}:{{ item.pdc_addtime_text }}</label>
              </div>
            </div>
          </div>
          <empty-record v-else-if="withdraw_list && !withdraw_list.length"></empty-record>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getWithdrawList,
  addGoldCardBalanceWithdraw,
  getWithdrawListGoldBalance,
  createToken,
} from "../../../api/memberWithdraw";
import { getMemberIndex } from "../../../api/member";
import { getBankList } from "../../../api/memberBank";
import { Toast, Indicator, MessageBox } from "mint-ui";
import EmptyRecord from "../../../components/EmptyRecord";
import flexLine from "../../flexLine";
import { sendAuthEmailCodeGold } from '../../../api/memberSetting'
export default {
  name: "MemberWithdrawList",
  components: {
    flexLine,
    EmptyRecord,
  },
  data() {
    return {
      address_type: "",
      params: { page: 0, per_page: 10 },
      loading: false,
      isMore: true,
      bank_length: 0,
      amount: "",
      memberbankList: {},
      memberbankOptions: [],
      memberbank_name: "",
      memberbank_id: "",
      password: "",
      form_token: "",
      addWithdrawVisible: false,
      memberbankVisible: false,
      sendAuthCode: false,
      wrapperHeight: 0,
      withdraw_list: false,
      usdt_address: "",
      gold_card_balance: 0.0,
      btnShow: true,
      showPassword: false,

      email_code: "",
      canSendEmail: true,
      verifyCodeMobile: '',
      sendStateTextMobile: this.$t('send'),
      next_withdraw_time: 0,
    };
  },
  created() {
    this.getWithdrawList()
    getBankList()
      .then((res) => {
        let temp = res.result.bank_list;
        this.bank_length = temp.length;
        if (this.bank_length > 0) {
          this.usdt_address = temp[0].memberbank_no;
          this.memberbank_id = temp[0].memberbank_id;
          this.address_type = temp[0].address_type;
        } else {
          this.btnShow = false;
        }
      })
      .catch(function (error) {
        Toast(error.message);
      });
    createToken().then((res) => {
      if (res.code == 10000) {
        this.form_token = res.result.form_token;
      }
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.member.info,
    }),
  },
  mounted() {
    this.wrapperHeight = document.documentElement.clientHeight - 90;
  },
  methods: {
    sendVerifyCode(){
      if (this.amount == "") {
        Toast(this.$t("Please enter") + this.$t("Withdrawal Amount"));
        return;
      }
      if (this.password == "") {
        Toast("Please enter payment password");
        return;
      }
      if (Number(this.amount) > Number(this.gold_card_balance)) {
        Toast('Insufficient gold card balance');
        return;
      }
      if(this.next_withdraw_time != 0){
        Toast(`Next withdrawal time\n\n${this.next_withdraw_time}`)
        return;
      }
      if (!this.canSendEmail) {
        return
      }
      Indicator.open()
      sendAuthEmailCodeGold(this.password, this.amount).then(res => {
        Indicator.close()
        Toast(res.message)
        if (res.code != 10000) {
          return
        }
        this.canSendEmail = false
        let second = 180
        let _this = this
        this.timeIntervalMobile = setInterval(function () {
          if (second <= 0) {
            _this.canSendEmail = true
            _this.sendStateTextMobile = _this.$t('send')
            clearInterval(_this.timeIntervalMobile)
          } else {
            _this.sendStateTextMobile = second + 's'
          }
          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    onRetrieve() {
      this.$router.push({
        name: "HomeMemberForget",
        query: { type: "pay_password" },
      });
    },
    setMemberBank(e) {
      this.memberbank_name = this.memberbankList[e];
      this.memberbankVisible = false;
    },
    addWithdraw() {
      if(this.next_withdraw_time != 0){
        Toast('Next withdrawal time:'+this.next_withdraw_time);
        return;
      }
      let that = this;
      if (this.amount == "") {
        Toast(this.$t("Please enter") + this.$t("Withdrawal Amount"));
        return;
      }
      MessageBox({
        title: that.$t("MessageBox.Tips"),
        message:
          that.$t("MessageBox.Confirm") + " " + that.$t("Withdraw") + "?",
        confirmButtonText: that.$t("MessageBox.Confirm"),
        cancelButtonText: that.$t("MessageBox.Cancel"),
        showCancelButton: true,
      }).then((action) => {
        if (action == "confirm") {
          addGoldCardBalanceWithdraw(
            this.amount,
            this.memberbank_id,
            this.password,
            this.form_token,
            this.address_type,
            this.email_code
          ).then((res) => {
              if (res.code == 10000) {
                this.password = ''
                this.amount = ''
                this.canSendEmail = true
                this.email_code = ''
                clearInterval(this.timeIntervalMobile)
                this.sendStateTextMobile = this.$t('send')
                this.getWithdrawList(true)
              }
              Toast(res.message);
            })
            .catch(function (error) {
              Toast(error.message);
            });
        }
      });
    },
    checkSuccess() {
      this.addWithdrawVisible = true;
    },
    goAdd() {
      this.addWithdrawVisible = true;
    },
    goBack() {
      this.$router.go(-1);
    },
    goMemberbacklist(backTo) {
      this.$router.push({
        name: "MemberBankForm",
        query: { action: "add", backTo },
      });
    },
    loadMore() {
      this.loading = true;
      this.params.page = ++this.params.page;
      if (this.isMore) {
        this.loading = false;
        this.getWithdrawList(true);
      }
    },
    getWithdrawList() {
      Indicator.open();
      getWithdrawListGoldBalance(this.params).then((res) => {
          Indicator.close();
          if (res.result.hasmore) {
            this.isMore = true;
          } else {
            this.isMore = false;
          }
          let temp = res.result.list;
          this.gold_card_balance = res.result.gold_card_balance;
          this.next_withdraw_time = res.result.next_withdraw_time
          if (temp) {
            if (!this.withdraw_list) {
              this.withdraw_list = temp;
            } else {
              this.withdraw_list = this.withdraw_list.concat(temp);
            }
          }
        })
        .catch(function (error) {
          Indicator.close();
          Toast(error.message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.send-btn{color:#ffffff;cursor: pointer;}
.member-withdraw-list {
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

.common-header-wrap {
  .common-header {
    box-shadow: none;
  }
}

.content {
  padding: 20px;
  width: 800px;
  margin: 0 auto;
  
  .centerbox {
    background-image: url("../../../assets/image/walletpop.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 30px;
    border-radius: 10px;
    margin-bottom: 30px;

    .common-btn {
      margin: 1rem auto;
      background: linear-gradient(90deg, #e8090c 0%, #f3611e);
      width: 200px;
      height: 45px;
      line-height: 45px;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
    }

    .balance {
      text-align: right;
      font-size: 14px;
      color: #999;
    }
  }
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0.4rem 0;

  .field-name {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    margin: 0.5rem 0;
  }

  input {
    font-size: 14px;
    width: 100%;
    text-align: left !important;
    padding: 0.9rem;
    border-radius: 0.4rem;
    background: #fafafa;
    border: none;
  }

  .field-line-right {
    width: 100%;
    word-wrap: normal;
    position: relative;
  }

  ::v-deep(.right) {
    width: 100%;
  }
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.8rem 0;
}

.fundet {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .tit {
    margin-bottom: 20px;
    display: inline-block;
    color: black;
    padding: 0.5rem 0rem 0px;
    font-weight: bold;
    font-size: 18px;
    border-bottom: none;
    background-image: linear-gradient(
      90deg,
      #e8090c 30%,
      rgba(243, 97, 30, 0.8) 20%,
      rgba(240, 240, 240, 0.9) 70%
    );
    background-size: 100% 5px;
    background-repeat: no-repeat;
    background-position: bottom;
  }
}

.list-wrapper {
  background-color: #fff;
  margin-top: 1rem;
  border-radius: 10px;
  border: 1px solid #e8eaed;
  padding: 1rem;

  .container-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
    padding: 0 0 0.75rem 0;
    border-bottom: 1px solid #e8eaed;

    &:last-child {
      border-bottom: none;
    }
  }

  .top-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
  }

  .left-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .right-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .status {
    font-size: 14px;
    color: #5296db;
    margin-left: 0.75rem;
    margin-top: 0.65rem;
  }

  .title {
    font-size: 14px;
    color: #666666;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
    margin-right: 0.5rem;
    margin-bottom: 0.2rem;
    width: 400px;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }

  .price {
    font-size: 20px;
    color: $primaryColor;
    margin-right: 0.75rem;
    margin-top: 0.5rem;
    text-align: right;
  }

  .subtitle {
    font-size: 14px;
    color: #999999;
    margin-right: 0.75rem;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    text-align: right;
  }

  .desc {
    color: #999999;
    font-size: 14px;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .center-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding-bottom: 0.25rem;
  }
}

::v-deep(.flex-line) {
  background-color: transparent;
  align-items: flex-start !important;
}

.ds-button-large {
  margin: 20px auto !important;
}
</style>
